import { Floorplan } from 'floorplan/pages/native-floorplan/types';

/**
 * Which floor the map is on, given what the url asks for.
 *
 * An unknown or missing uuid falls back to the **first of the list as given** — which covers opening
 * the map with no floor chosen and a stale link to a floorplan that has since been deleted.
 *
 * "First" is the caller's order on purpose, not a re-derivation from `sortOrder`. `useFloorplansQuery`
 * already sorts by `sortOrder` in its query function (with two tests pinning it, including one for
 * ties), so its consumers are handed an ordered list; and the floor chips render that same list in
 * array order. Picking the lowest `sortOrder` here instead would only differ if the array were
 * unordered — in which case it would land on a floor that is *not* the first chip, so the fallback
 * would disagree with what the user sees. One ordering rule, in the layer that owns the data.
 *
 * A plain function rather than part of `useActiveFloorplan`, because the filters sheet has to resolve
 * the same floor from a different subtree: two copies of the fallback rule would be one too many.
 */
export const findActiveFloorplan = (floorplans: Floorplan[], selectedUuid?: string): Floorplan | null =>
  floorplans.find(({ uuid }) => uuid === selectedUuid) ?? floorplans[0] ?? null;
